import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ErrorToaster, SuccessToaster } from "../components/toaster/Toaster";
import { setUserDetail } from "../../core/redux/action";
import { useForm } from "react-hook-form";
import InputField from "../components/Input";
import { IMAGE_BASE_URL } from "../../config/constants";
import { noDoubleQuotes, passwordRegex } from "../../utils";
import { Spinner } from "react-bootstrap";
import AuthServices from "../../services/Auth";
import ProfileServices from "../../services/Profile";

const Profile = () => {

  const dispatch = useDispatch();

  const { userData } = useSelector((state) => {
    return {
      userData: state.user_detail
    }
  });

  const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
  const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 }, reset: reset2, watch } = useForm();
  const newPassword = useRef({});
  newPassword.current = watch("newPassword", "");

  const [loading, setLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);

  // *For Logo
  const [isLogo, setIsLogo] = useState({});

  // *For Password Visibility Toggle
  const [isCurrentPasswordVisible, setCurrentPasswordVisible] = useState(false);
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  // *For Upload Image
  const allowFilesType = ['image/png', 'image/jpg', 'image/jpeg']
  const handleUploadImage = (e) => {
    try {
      if (e.target.value !== "") {
        const file = e.target.files[0]

        if (file.size > 1024 * 1024) { // 1 MB limit
          ErrorToaster("File size must be less than 1MB");
          return;
        }

        if (allowFilesType.includes(file.type)) {
          const imgReader = new FileReader();
          imgReader.onload = (event) => {
            let obj = {
              file: file,
              image: event.target.result
            }
            setIsLogo(obj)
          };
          imgReader.readAsDataURL(file);
        } else {
          ErrorToaster("Only png, jpg, and jpeg formats is supported")
        }
      }
    } catch (error) {
      console.log('handleUploadImage => error:', error)
    }
  };

  // *For Submit Form
  const submitForm = async (payload) => {
    setLoading(true)
    try {
      const formData = new FormData();
      formData.append('name', payload?.name);
      formData.append('phone', payload?.phone);
      formData.append('ntn_cnic', payload?.ntnCnic);
      formData.append('strn', payload?.strn);
      formData.append('address', payload?.address);
      formData.append('province', payload?.province);
      if (isLogo?.file) {
        formData.append('logo', isLogo?.file);
      }
      const { message, data } = await ProfileServices.updateProfile(formData)
      SuccessToaster(message)
      dispatch(setUserDetail({ ...userData, ...data }))
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  // *For Change Password Form
  const submitPasswordForm = async (payload) => {
    setPasswordLoading(true)
    try {
      const obj = {
        old_password: payload.currentPassword,
        new_password: payload.newPassword
      }
      const { message } = await AuthServices.changePassword(obj)
      SuccessToaster(message)
      reset2()
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setPasswordLoading(false)
    }
  }

  useEffect(() => {
    if (userData) {
      setValue("name", userData?.name)
      setValue("phone", userData?.phone)
      setValue("email", userData?.email)
      setValue("ntnCnic", userData?.ntn_cnic)
      setValue("strn", userData?.strn)
      setValue("address", userData?.address)
      setValue("province", userData?.province)
      setIsLogo({
        file: null,
        image: `${IMAGE_BASE_URL}${userData?.logo}`
      })
    }
  }, [userData]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Profile</h4>
            <h6>User Profile</h6>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-head"></div>
              <div className="profile-top">
                <div className="profile-content">
                  <div className="profile-contentimg">
                    <img
                      src={isLogo?.image}
                      alt="img"
                      style={{
                        width: "110px",
                        height: "110px",
                        objectFit: "contain",
                      }}
                    />
                    <div className="profileupload">
                      <input type="file" id="imgInp" onChange={(e) => handleUploadImage(e)} />
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/icons/edit-set.svg"
                          alt="img"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="profile-contentname">
                    <h2>{userData?.name}</h2>
                    <h4>Updates Your Logo and Personal Details.</h4>
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit(submitForm)}>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Name*"
                      type="text"
                      error={errors?.name?.message}
                      register={register("name", {
                        required: 'Please enter store name.',
                        ...noDoubleQuotes()
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Phone"
                      type="tel"
                      register={register("phone")}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Email"
                      type="email"
                      disabled={true}
                      register={register("email")}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="NTN/CNIC*"
                      type="text"
                      error={errors?.ntnCnic?.message}
                      register={register("ntnCnic", {
                        required: 'Please enter NTN/CNIC.',
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="STRN"
                      type="text"
                      register={register("strn")}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Address*"
                      type="text"
                      error={errors?.address?.message}
                      register={register("address", {
                        required: 'Please enter address.',
                        ...noDoubleQuotes()
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product">
                    <InputField
                      label="Province*"
                      type="text"
                      error={errors?.province?.message}
                      register={register("province", {
                        required: 'Please enter province.',
                        ...noDoubleQuotes()
                      })}
                    />
                  </div>
                </div>
                <div className="text-end col-12">
                  <button
                    type="submit"
                    className="btn btn-submit"
                    disabled={loading}
                  >
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="page-header">
              <div className="page-title">
                <h4>Change Password</h4>
                <h6>Update your password</h6>
              </div>
            </div>
            <form onSubmit={handleSubmit2(submitPasswordForm)}>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product pass-group">
                    <InputField
                      label="Current Password"
                      type={isCurrentPasswordVisible ? "text" : "password"}
                      endAdornment={
                        <span
                          className={`fas toggle-password ${isCurrentPasswordVisible ? "fa-eye" : "fa-eye-slash"
                            }`}
                          onClick={() => setCurrentPasswordVisible((prevState) => !prevState)}
                        ></span>
                      }
                      error={errors2?.currentPassword?.message}
                      register={register2("currentPassword", {
                        required: 'Please enter the current password.',
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product pass-group">
                    <InputField
                      label="New Password"
                      type={isPasswordVisible ? "text" : "password"}
                      endAdornment={
                        <span
                          className={`fas toggle-password ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"
                            }`}
                          onClick={() => setPasswordVisible((prevState) => !prevState)}
                        ></span>
                      }
                      error={errors2?.newPassword?.message}
                      register={register2("newPassword", {
                        required: 'Please enter the new password.',
                        pattern: {
                          value: passwordRegex,
                          message: 'Password contain minimum 8 characters, at least uppercase/lowercase letter, number and special character',
                        }
                      })}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="mb-3 add-product pass-group">
                    <InputField
                      label="Confirm Password"
                      type={isConfirmPasswordVisible ? "text" : "password"}
                      endAdornment={
                        <span
                          className={`fas toggle-password ${isConfirmPasswordVisible ? "fa-eye" : "fa-eye-slash"
                            }`}
                          onClick={() => setConfirmPasswordVisible((prevState) => !prevState)}
                        ></span>
                      }
                      error={errors2?.confirmPassword?.message}
                      register={register2("confirmPassword", {
                        required: 'Please enter the confirm password.',
                        validate: value => value === newPassword.current || "Confirm password does not match"
                      })}
                    />
                  </div>
                </div>
                <div className="text-end col-12">
                  <button
                    type="submit"
                    className="btn btn-submit"
                    disabled={passwordLoading}
                  >
                    {passwordLoading &&
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                    }
                    Change Password
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
